// import { colors } from '../foundations';
import { css } from '@emotion/react';
import {
  ContentBlock,
  CTAProps,
  HeaderTagTypes,
  OrientationTypes
} from './content-block';
import { AspectRatios } from './image';
import { getColor, ExportableAdgColorTypes } from './../foundations/adg-colors';
import { IconNameTypes } from './../foundations/icon';

type ColorBarPositions = 'top' | 'bottom' | 'both' | 'none';

export interface CardProps {
  headerText: string;
  bodyText: string;
  headerType?: HeaderTagTypes;
  borderHeader?: boolean;
  eyebrowText?: string;
  footerHeader?: string;
  footerText?: string;
  imageLink?: string;
  altText?: string;
  backgroundColor?: ExportableAdgColorTypes;
  textColor?: ExportableAdgColorTypes;
  iconName?: IconNameTypes;
  iconColor?: ExportableAdgColorTypes;
  orientation?: OrientationTypes;
  aspectRatio?: AspectRatios;
  colorBars?: ColorBarPositions;
  barColor?: ExportableAdgColorTypes;
  ctaProps?: CTAProps;
  className?: string;
}

const containerStyles = (
  backgroundColor: ExportableAdgColorTypes | undefined,
  textColor: string | undefined
) => css`
  background: ${backgroundColor ? getColor(backgroundColor) : getColor('n0')};
  color: ${textColor ? getColor(textColor) : getColor('n900')};
  border-radius: 2px;
  box-shadow: 0px 4px 6px 3px #42526e29;
  display: flex;
  flex-direction: column;
  max-width: 1100px;
  container-type: inline-size;
`;

const barStyles = (
  color: ExportableAdgColorTypes | undefined,
  isTop: boolean
) => css`
  background-color: ${color ? getColor(color) : getColor('b400')};
  margin: 0;
  padding: 0;
  width: 100%;
  height: 8px;
  ${isTop
    ? 'border-top-right-radius: 4px; border-top-left-radius: 4px;'
    : 'border-bottom-right-radius: 4px; border-bottom-left-radius: 4px;'}
`;

export const Card = (props: CardProps) => {
  const {
    textColor,
    headerType,
    headerText,
    bodyText,
    eyebrowText,
    footerHeader,
    footerText,
    imageLink,
    altText,
    backgroundColor,
    colorBars,
    iconName,
    iconColor,
    barColor,
    className,
    ctaProps,
    aspectRatio,
    orientation
  } = props;

  if (imageLink && !altText) {
    throw new Error(
      'If using an image, please provide an alt text for accessibility purposes!'
    );
  }

  return (
    <div
      className={className}
      css={containerStyles(backgroundColor, textColor)}
    >
      {colorBars == 'top' || colorBars == 'both' ? (
        <div css={barStyles(barColor, true)} />
      ) : (
        ''
      )}

      <ContentBlock
        cardStyle={true}
        aspectRatio={aspectRatio}
        orientation={orientation}
        headerType={headerType}
        headerText={headerText}
        bodyText={bodyText}
        imageLink={imageLink}
        altText={altText}
        eyebrowText={eyebrowText}
        footerHeader={footerHeader}
        footerText={footerText}
        iconColor={iconColor}
        iconName={iconName}
        ctaProps={ctaProps}
      />

      {colorBars == 'bottom' || colorBars == 'both' ? (
        <div css={barStyles(barColor, false)} />
      ) : (
        ''
      )}
    </div>
  );
};
